import React from "react";
import "./CarCardLoadMore.css";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

function CarCardLoadMore({ onClick, disabled }) {
  return (
    <div
      className={`car_card_load_container ${disabled ? "disabled" : ""}`}
      onClick={onClick}
      key="load_more_button"
    >
      <KeyboardArrowRightIcon className="car_card_load_icon" />
    </div>
  );
}

export default CarCardLoadMore;
